export const createConditionalRequire = (getter, fieldName, value, otherOptions = {}) =>
    ({validate: input => getter(fieldName) === value ? !!input : true, ...otherOptions});

export const createValueGroupRequired = (getter, fieldName) => ({
    validate: () => Object.values(getter()[fieldName]).includes(true)
});
